var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99992 9.99998C11.8416 9.99998 13.3333 8.50831 13.3333 6.66665C13.3333 4.82498 11.8416 3.33331 9.99992 3.33331C8.15825 3.33331 6.66659 4.82498 6.66659 6.66665C6.66659 8.50831 8.15825 9.99998 9.99992 9.99998ZM9.99992 11.6666C7.77492 11.6666 3.33325 12.7833 3.33325 15V16.6666H10.2415C10.0843 16.1386 9.99992 15.5791 9.99992 15C9.99992 13.7871 10.3701 12.6606 11.0037 11.7274C10.6397 11.6869 10.2997 11.6666 9.99992 11.6666ZM12.4999 10.8333V12.3275H14.8963V18.3333H16.5321V12.3275H18.9285V10.8333H12.4999Z",
    fill: "#6F7071"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonTest);
export default __webpack_public_path__ + "static/media/personTest.e5455ce67b2b14c861f99e5b1f9f9980.svg";
export { ForwardRef as ReactComponent };